import React from 'react';
import TrafficLandingTemplate, { LandingPageConfig } from './TrafficLandingTemplate';
import { Activity, BarChart3, Globe } from 'lucide-react';

const config: LandingPageConfig = {
    slug: 'ar/muwallid-traffic-mawqi',
    titleTag: 'مولد حركة مرور الموقع للحملات | Traffic Creator',
    metaDescription: 'استخدم مولد حركة مرور الموقع من Traffic Creator لجلسات سكنية مرئية في GA4، استهداف 190+ دولة، ضوابط مدة وارتداد، وتقارير أوضح.',
    keywords: 'مولد حركة مرور الموقع, Traffic Creator',
    primaryKeyword: 'مولد حركة مرور الموقع',
    secondaryKeyword: 'Traffic Creator',
    reviewCount: '324',
    ratingValue: '4.9',

    h1: 'مولد حركة مرور الموقع',
    subheadline: 'كل ما تحتاجه لتعزيز أداء موقعك وترتيب البحث. حركة مرور سكنية حقيقية من 190+ دولة مُتحققة في Google Analytics 4.',

    problemH2: 'مولد حركة مرور الموقع — شبكة IP سكنية',
    problemText: 'كل زيارة تأتي من عنوان IP سكني حقيقي لا يمكن اكتشافه بواسطة منصات التحليلات. حركة مرور طبيعية المظهر تعمل.',
    solutionPoints: [
        'عناوين IP سكنية حقيقية من 190+ دولة',
        'جلسات متصفح كاملة مع سلوك طبيعي',
        'كل جلسة مرئية في Google Analytics 4',
        'آمن للسيو — بدون كشف بوت'
    ],

    featuresH2: 'مولد حركة مرور الموقع — مُتحقق في GA4',
    features: [
        { icon: <Activity />, title: 'شبكة IP سكنية', description: 'كل زيارة من عنوان IP سكني حقيقي لا يمكن اكتشافه بواسطة منصات التحليلات.' },
        { icon: <BarChart3 />, title: 'زيارات مُتحققة في GA4', description: 'شاهد كل جلسة في الوقت الفعلي في لوحة Google Analytics 4 مع إحصائيات دقيقة.' },
        { icon: <Globe />, title: 'استهداف جغرافي دقيق', description: 'استهدف زواراً من دول ومناطق ومدن محددة لتحقيق أقصى فعالية.' }
    ],

    testimonialsH2: 'مولد حركة مرور الموقع — +300% زيارات',
    testimonials: [
        { name: 'محمد ع.', role: 'استراتيجي رقمي', result: '+300% زيارات', text: 'Traffic Creator يقدم بالضبط ما نحتاجه. الزيارات عالية الجودة وتظهر بشكل موثوق في GA4.', seed: 'arwebsitet1' },
        { name: 'ريم ك.', role: 'مديرة تسويق', result: 'معدل ارتداد أقل', text: 'بعد التحول لاحظنا فرقاً فورياً. زوار حقيقيون مع تفاعل حقيقي.', seed: 'arwebsitet2' },
        { name: 'علي ب.', role: 'رائد أعمال رقمي', result: 'ترتيب أفضل', text: 'الزيارات من IP سكنية تعمل بشكل ممتاز. مقاييس SEO تحسنت بشكل كبير.', seed: 'arwebsitet3' }
    ],

    ctaH2: 'جرب مجاناً — مولد حركة مرور الموقع',

    faqs: [
        { question: 'كيف يعمل النظام؟', answer: 'نظامنا يوجه زواراً حقيقيين عبر عناوين IP سكنية من 190+ دولة مع محاكاة سلوك مستخدم طبيعي.' },
        { question: 'هل هو آمن لموقعي؟', answer: 'نعم، آمن تماماً. زياراتنا من عناوين IP سكنية حقيقية ولا يمكن اكتشافها بواسطة Google ومنصات التحليلات.' },
        { question: 'هل ستظهر الزيارات في Google Analytics؟', answer: 'بالتأكيد. كل زيارة تُسجل بالكامل في GA4 مع مدة الجلسة والصفحات لكل زيارة والبيانات الجغرافية.' },
        { question: 'ما سرعة بدء التسليم؟', answer: 'خلال 5 دقائق من إعداد الحملة يبدأ الزوار الأوائل بالوصول إلى موقعك.' },
        { question: 'هل هناك تجربة مجانية؟', answer: 'نعم! سجّل وابدأ حملتك الأولى مجاناً. لا حاجة لبطاقة ائتمان.' }
    ],

    relatedLinks: [
        { label: 'شراء حركة مرور الموقع', to: '/ar/shira-traffic-mawqi' },
        { label: 'بوت حركة المرور', to: '/ar/bot-traffic' },
        { label: 'معزز حركة مرور SEO', to: '/ar/muazziz-traffic-seo' }
    ],

    productName: 'مولد حركة مرور الموقع',
    productDescription: 'مولد حركة مرور الموقع — Traffic Creator يقدم حركة مرور سكنية متميزة مُتحققة في GA4 من 190+ دولة. جرب مجاناً.',

    translations: {
        navFeatures: 'الميزات',
        navPricing: 'الأسعار',
        navFaq: 'الأسئلة الشائعة',
        navLogin: 'تسجيل الدخول',
        heroBadge: 'حركة مرور عالية الجودة',
        heroCtaPrimary: 'جرب مجاناً',
        heroCtaSecondary: 'عرض الأسعار',
        heroTrust: 'يثق بنا أكثر من 10,000 مستخدم',
        heroMicrocopy: 'لا حاجة لبطاقة ائتمان. آمن 100% ومُتحقق في التحليلات.',
        heroLiveLabel: 'مباشر',
        heroTrafficIncrease: 'زيادة حركة المرور',
        heroActiveLabel: 'نشط',
        heroVisitorsServed: 'زوار تم خدمتهم',
        socialProofLabel: 'موثوق من قبل:',
        problemWithout: 'بدون',
        problemWith: 'مع',
        problemBullets: [
            'حركة المرور العضوية المنخفضة تحد من نموك',
            'نتائج البحث السيئة تضر بالتحويلات',
            'المنافسون يهيمنون على كلماتك المفتاحية',
            'معدل الارتداد المرتفع يضر بالسيو',
        ],
        statsCampaigns: 'حملات نشطة يومياً',
        statsCountries: 'دولة',
        statsUptime: 'وقت التشغيل',
        statsSupport: 'الدعم',
        featuresSubtitle: 'كل ما تحتاجه لتعزيز أداء موقعك وترتيب البحث.',
        howItWorksH2: '3 خطوات بسيطة',
        howItWorksSteps: [
            { title: 'إعداد الحملة', desc: 'اختر البلد والجهاز وإعدادات السلوك في دقائق.' },
            { title: 'تشغيل الشبكة', desc: 'استرخِ بينما توجه منصتنا زواراً حقيقيين إلى رابطك.' },
            { title: 'تحليل النتائج', desc: 'شاهد تحسن مقاييسك في Google Analytics 4.' },
        ],
        pricingH2: 'أسعار شفافة',
        pricingSubtitle: 'شراء لمرة واحدة. بدون اشتراكات. الأرصدة لا تنتهي صلاحيتها.',
        pricingMostPopular: 'الأكثر شعبية',
        pricingVisitors: 'زائر',
        pricingGetStarted: 'ابدأ الآن',
        pricingGuarantee: 'ضمان استرداد المال لمدة 30 يوماً',
        pricingDelivery: 'تسليم فوري (~5 دقائق)',
        pricingCountries: '190+ دولة',
        faqH2: 'الأسئلة الشائعة',
        ctaSubtitle: 'انضم إلى أكثر من 10,000 عميل وعزز حركة مرور موقعك اليوم.',
        ctaButtonPrimary: 'ابدأ مجاناً',
        ctaButtonSecondary: 'عرض الأسعار',
        ctaMicrocopy: 'لا حاجة لبطاقة ائتمان. آمن 100% ومُتحقق في التحليلات.',
        footerDescription: 'حلول لمحترفي السيو والوكالات الرقمية حول العالم.',
        footerRelatedServices: 'خدمات ذات صلة',
        footerCompany: 'الشركة',
        footerAbout: 'من نحن',
        footerBlog: 'المدونة',
        footerHelpCenter: 'مركز المساعدة',
        footerPrivacy: 'سياسة الخصوصية',
        footerImpressum: 'البيانات القانونية',
        footerStatus: 'جميع الأنظمة تعمل',
        footerBuyTraffic: 'شراء حركة مرور الموقع',
    }
};

const ArWebsiteTrafficGenerator: React.FC = () => {
    return <TrafficLandingTemplate config={config} />;
};

export default ArWebsiteTrafficGenerator;
